// src/components/chat/Message.tsx
import { cn } from '@/lib/utils';
import { format } from 'date-fns';

interface MessageProps {
  message: {
    content: string;
    role: 'user' | 'assistant';
    timestamp?: Date;
  };
}

export function Message({ message }: MessageProps) {
  const isUser = message.role === 'user';
  const formattedTime = message.timestamp ? format(new Date(message.timestamp), 'h:mm a') : '';

  return (
    <div
      className={cn(
        'flex mb-4 group',
        isUser ? 'justify-end' : 'justify-start'
      )}
    >
      <div className="flex flex-col max-w-[85%]">
        <div
          className={cn(
            'rounded-lg px-4 py-2 relative',
            isUser
              ? 'bg-blue-500 text-white rounded-br-none'
              : 'bg-gray-100 text-gray-800 rounded-bl-none'
          )}
        >
          <p className="whitespace-pre-wrap break-words">{message.content}</p>
          
          {/* Timestamp */}
          <div 
            className={cn(
              'text-xs mt-1 opacity-0 group-hover:opacity-70 transition-opacity',
              isUser ? 'text-blue-100 text-right' : 'text-gray-500'
            )}
          >
            {formattedTime}
          </div>
          
          {/* Role indicator */}
          <div 
            className={cn(
              'absolute -top-2 text-[10px] font-medium px-2 py-0.5 rounded-full',
              isUser 
                ? 'right-2 bg-blue-600 text-white' 
                : 'left-2 bg-gray-200 text-gray-600'
            )}
          >
            {isUser ? 'You' : 'AI'}
          </div>
        </div>
      </div>
    </div>
  );
}